module.exports = __webpack_public_path__ + "img/competitor-analysis.8578c7e3.svg";